import React from "react";
import { Tooltip } from "antd";
import copy from "copy-to-clipboard";
import { Typography, IconButton } from "@mui/material";
import Events from "../../Analytics/Events";
import CustomIcon from "../../Components/CustomIcon";

function TextWithCopyIcon(text, type, textStyle={}, toolTipPlacement="top", label=null, iconStyle={}, iconButtonStyle={}, showLabelTooltip=false) {
  // Nothing to copy means no copy button: it would offer to put an empty string on
  // the clipboard, and next to a blank cell it reads as a broken control. The label
  // is still rendered, so a caller passing one for an absent value keeps it.
  //
  // Checked explicitly rather than with a falsy test, so a legitimate 0 keeps its
  // copy button. Mirrors the same guard in the shared table renderer
  // (Features/Table/GenericDraggableTable/Renderers/TableColumnValueRenderer.jsx).
  if (text === null || text === undefined || text === "") {
    return (
      <Typography style={textStyle} variant="fw400s14lh24c3D4B5A">{label || ""}</Typography>
    );
  }

  return (
    <>
      {showLabelTooltip 
      ? <Tooltip
          placement="top"
          title={text}
          zIndex={2000}
        >
          <Typography style={textStyle} variant="fw400s14lh24c3D4B5A">{label || text}</Typography>
        </Tooltip>
      : <Typography style={textStyle} variant="fw400s14lh24c3D4B5A">{label || text}</Typography>
      }

      <Tooltip title={"Click to copy"} placement={toolTipPlacement}>
        <IconButton
         disableRipple
         disableTouchRipple
         disableFocusRipple
          sx={{ 
            py: 0,
            ...iconButtonStyle
          }}
          onClick={(event) => {
            event.stopPropagation();
            copy(text);
            Events(`Copied ${type}`);
          }}
        >
          <CustomIcon name = "copy-icon"/>
        </IconButton>
      </Tooltip>
    </>
  );
}

export default TextWithCopyIcon;
